import { Component, OnDestroy, OnInit } from '@angular/core';
import { EnvironmentService } from '@library/core/services';
import { NavItem, NavMenuService } from '@library/modules/menu';
import { ScheduleReportService } from '@library/modules/reports/schedule-report/schedule-report.service';
import { UseraccessService } from '@library/modules/user';
import { forkJoin, Subscription } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

const MenuItems: NavItem[] = [
   // { label: 'Manage',       path: '/manage',    icon: 'shipments' },
   // { label: 'Create',       path: '/create',    icon: 'createshipment' },
   // { label: 'Create Shipment', path: '/shipment',     icon: 'createshipment', access: 'booking'   },
   { label: 'Templates',       path: '/template',     icon: 'templates',      access: 'booking'   },
   { label: 'Invoices',        path: '/invoice',      icon: 'invoices',       access: 'invoicing' },
   { label: 'Reports',         path: '/report',       icon: 'reports',        access: 'tracking'  },
   { label: 'Activity Feed',   path: '/activityfeed', icon: 'activityfeed',   access: 'tracking'  },
   { label: 'Address Book',    path: '/addressbook',  icon: 'addressbook',    access: 'booking'   },
   // { label: 'Admin',           path: '/admin',        icon: 'admin',          access: 'admin' },
];

@UntilDestroy()
@Component({
   selector: 'app-menu',
   templateUrl: './menu.component.html',
   styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {

   private menus: NavItem[] = MenuItems;

   public loaded: boolean = false;

   private sub$: Subscription = new Subscription();

   constructor(
      private nav: NavMenuService,
      private scheduleReportService: ScheduleReportService,
      private access: UseraccessService,
      
      public environment: EnvironmentService,
   ) {
      
   }

   ngOnInit(): void {
      forkJoin([
         this.access.hasAccess('quoting'),
         this.access.hasAccess('tracking'),
         this.access.hasAccess('booking'),
      ])
      .pipe(
         untilDestroyed(this),
      )
      .subscribe(([ quote, track, booking ]) => {
         this.menus = [];

         // for the listing
         if ( quote && track ) {
            this.menus.push({ label: 'Manage',       path: '/manage',    icon: 'shipments' });
         } else if ( quote ) {
            this.menus.push({ label: 'Quotations',       path: '/manage',    icon: 'shipments' });
         } else if ( track ) {
            this.menus.push({ label: 'Shipments',       path: '/manage',    icon: 'shipments' });
         }

         // For the create
         if ( quote && booking ) {
            this.menus.push({ label: 'Create',       path: '/create',    icon: 'createshipment' });
         } else if ( quote ) {
            this.menus.push({ label: 'Create Quotation',       path: '/create',    icon: 'createshipment' });
         } else if ( booking ) {
            this.menus.push({ label: 'Create Shipments',       path: '/create',    icon: 'createshipment' });
         }

         this.menus.push( ...MenuItems );

         this.loaded = true;

         this.sub$.add(this.nav.load( this.menus, this.scheduleReportService ));
         this.nav.showTracking = true;
         this.nav.title = 'customer portal';
      });
   }

   ngOnDestroy(): void {
      this.sub$.unsubscribe();
   }
}
